<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
   <div>
      <Breadcrumbs main="Products" title="Sold Products" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
               <div class="card">
                  <div class="card-body">

                     <div class="col-md-12 project-list page-subtitle">
                           <div class="row">
                              <div class="col-md-10 d-flex">
                                 <span style="font-size: 20px; font-weight: bolder;">Sold Products</span>
                              </div>
                              <div class="col-md-2">
                                 <!-- <router-link :to="{ name: 'users.adduser' }" class="btn btn-primary">Add User</router-link> -->
                                 <router-link :to="{ name: 'addproduct' }" class="btn btn-primary">Add Product</router-link>
                              </div>
                                 
                           </div>
                     </div>

                     <div class="col-md-12 project-list filter-sort">
                        <div class="row">
                           <div class="col-md-9 d-flex">
                              <label class="d-flex listing-length">
                                 <span>Show</span>
                                 <select class="form-select"  v-model="sold_listing_length" @change="fetchSoldProducts()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                 </select>
                                 <span>entries</span>
                              </label>
                           </div>
                                    
                           <div class="col-md-3">
                                 <input type="text" class="form-control" placeholder="Search" v-model="sold_keyword" @keyup="fetchSoldProducts()"/>
                           </div>
                        </div>
                     </div>

                        <div class="table-responsive product-table">
                           <table class="display" id="basic-1">
                              <thead>
                                 <tr>
                                    <th>Image</th>
                                    <th>Title</th>
                                    <th>Price</th>
                                    <th>Status</th>
                                    <th>Options</th>
                                 </tr>
                              </thead>
                              <tbody v-if="Boolean(sold_products.length)">
                                 <tr v-for="sold in sold_products" :key="sold.id">
                                    <td><img v-if="sold.image" :src="$image_url + sold.image" alt="Image not found" style="width:100px"></td>
                                    <td>{{sold.title}}</td>
                                    <td>Rs. {{sold.price}}</td>
                                    <td>
                                       
                                       <label v-if="sold.status==0">Blocked</label>
                                       <label v-if="sold.status==1">Active</label>
                                       <label v-if="sold.status==2">Requested</label>
                                       <label v-if="sold.status==3">Rejected</label>
                                       <label v-if="sold.status==4">Sold</label>
                                       
                                    </td>
                                    <td>
                                       <router-link :to="{name: 'product.show', params: { id: sold.id }}" class="btn btn-sm btn-primary mt-2 me-1" >View</router-link>


                                       <a href="#" class="btn btn-sm btn-primary mt-2 me-1" @click.prevent="setBackURL(sold.id)">{{sold.clicks}} Clicks <i class="fa fa-angle-double-right"></i></a>
                                       

                                       <a class="btn btn-danger mt-2 me-1 btn-sm" @click="deactivateProduct(sold)" v-if="sold.status==1">Deactivate</a>
                                       <a class="btn btn-success mt-2 me-1 btn-sm" @click="activateProduct(sold)" v-if="sold.status==0">Activate</a>                                   
                                    </td>
                                 </tr>
                              </tbody>
                              <tbody v-else>
                                 <tr>
                                    <td colspan="7" class="text-center">No data</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>

                        <!----pagination starts --->
                        <nav aria-label="Page navigation" class="mt-2">                    
                           <ul class="pagination">
                              <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in sold_pagination" :key="page.label">
                                 <a class="page-link" href="#" @click.prevent="fetchSoldProducts(page.url + '&limit='+ sold_listing_length + '&keyword=' + sold_keyword )" tabindex="-1">
                                    <span v-if="index == 0">Prev</span>
                                    <span v-else-if="index == sold_pagination.length-1">Next</span>
                                    <span v-else>{{page.label}}</span>
                                 </a>
                              </li>                        
                           </ul>
                        </nav>
                        <!----pagination ends --->

                  </div>
               </div>
            </div>
         </div>
      </div>


     
  </div>
</template>


<script>
export default {
   name:'SoldProducts',
   data() {
      return {
         
         sold_products: [],        
         sold_pagination: {},
         edit: false,
         product_status: {
            id: "",
            status: ""
         },
         
         sold_keyword: '',
         sold_listing_length: 10,
         token: '',
         errors: {},
         active_page_url: null,
         active_tab: 0,
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchSoldProducts();

   },

   methods: {      

      fetchSoldProducts(page_url=null) {
         let url = '/api/admin/products/sold?limit=' + this.sold_listing_length + '&keyword=' + this.sold_keyword;
         page_url = page_url || url;  

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
                     
            localStorage.removeItem('back_url');
         }    
         
         this.active_page_url = page_url;   
         this.getToken();
         this.$axios
            .get(page_url,{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;
               this.sold_products = responseData.data;               
               this.sold_pagination = responseData.links
               
            })
            .catch(err => console.log(err));
      },    

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

      setBackURL(product_id) {
         localStorage.setItem('back_url', this.active_page_url);
         this.$router.push({ name: 'products.clicks', params: { id: product_id } });
      },

      approveProduct(product) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to approve this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.product_status.id = product.id;
               this.product_status.status = '1';
               this.updateProductStatus(1);
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      rejectProduct(product) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to reject this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.product_status.id = product.id;
               this.product_status.status = '3';
               this.updateProductStatus(1);
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      activateProduct(product) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to activate this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.product_status.id = product.id;
               this.product_status.status = '1';
               this.updateProductStatus();
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      deactivateProduct(product) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to deactivate this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.product_status.id = product.id;
               this.product_status.status = '0';
               this.updateProductStatus();
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      updateProductStatus(approval = 0) {
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         let url;
         if(approval) {
            url = '/api/admin/products/approve?product_id=';
         } else {
            url = '/api/admin/products/status?product_id=';
         }
         this.$axios
         .get(url + this.product_status.id + '&status=' + this.product_status.status, config)
         .then(response => {
              if(response.data.status) {
                  this.$vToastify.success(response.data.message);
              } else {
                  this.$vToastify.error(response.data.message);
              }
              this.fetchProducts(this.active_page_url);
          })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                     this.$vToastify.error(error.response.message);
                  } else {
                     this.$vToastify.error("Error!");
                  }                  
               } else {
                  this.$vToastify.error("Error!");
               }
               
          });
      },
   }   
}
</script>